import React from "react";
import {createRoot} from "react-dom/client";
import "./index.css";
import App from "./components/App/App";
import {BrowserRouter as Router} from "react-router-dom";
import {store} from "./store/store";
import {Provider} from "react-redux";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>
);
